import { render } from "./sportsHealth.vue?vue&type=template&id=c95a2a80&scoped=true"
import script from "./sportsHealth.vue?vue&type=script&lang=js"
export * from "./sportsHealth.vue?vue&type=script&lang=js"

import "./sportsHealth.vue?vue&type=style&index=0&id=c95a2a80&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95a2a80"]])

export default __exports__